<template>
    <div ref="monthSelectionBlock">
        <div>
            <label v-if="labelContent" :for="uniqueId" class="mb-1 block text-sm text-gray-500">{{ labelContent }}</label>
            <button @click="openCloseSelection" :disabled="readOnly" :id="uniqueId" :class="readOnly ? 'bg-gray-300' : ''" class="h-[38px] w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
                <span>{{ labels.months[selectedParam] }}</span>
                <svg v-if="!readOnly" class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                </svg>
            </button>
        </div>
        <div v-show="selectionIsOpened" class="z-10 bg-white absolute rounded-lg shadow w-[17.675rem] dark:bg-gray-700">
            <div @click.stop class="flex items-start flex-col max-h-[10rem] p-3 overflow-y-auto text-sm text-gray-700 dark:text-gray-200">
                <RadioInput v-for="month in availableMonths" :key="month" @change="selectMonth(month)" v-model:radioParam="selectedParam" :name="uniqueId" :value="month" :labelContent="labels.months[month]"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid';
    import { mapState } from 'vuex';

    import RadioInput from './RadioInput.vue';

    export default {
        name: "MonthSelect",
        props: {
            labelContent: {
                type: [String, undefined, null],
                required: false,
            },
            selectParam: {
                type: [Object, null],
                required: true,
            },
            minValue: {
                type: [Number, null],
                required: false,
            },
            maxValue: {
                type: [Number, null],
                required: false,
            },
            readOnly: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            RadioInput,
        },
        computed: {
            ...mapState(["labels"]),
            availableMonths() {
                if (this.minValue && !this.maxValue) {
                    return [...this.months].filter(month => month >= this.minValue);
                } else if (this.maxValue && !this.minValue) {
                    return [...this.months].filter(month => month <= this.maxValue);
                } else if (this.minValue && this.maxValue) {
                    return [...this.months].filter(month => month >= this.minValue && month <= this.maxValue);
                } else {
                    return [...this.months];
                }
            }
        },
        data() {
            return {
                selectedParam: this.selectParam,
                selectionIsOpened: false,
                uniqueId: uuidv4(),
                months: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
            }
        },
        methods: {
            autoClose(event) {
                if (this.$refs.monthSelectionBlock && this.$refs.monthSelectionBlock.contains(event.target)) return;
                this.selectionIsOpened = false;
            },
            removeAutoCloseSelection() {
                document.body.removeEventListener("click", this.autoClose)
            },
            addAutoCloseSelection() {
                document.body.addEventListener("click", this.autoClose)
            },
            selectMonth(month) {
                this.selectedParam = month;
                this.$emit("update:selectParam", this.selectedParam);
                this.selectionIsOpened = false;
            },
            openCloseSelection() {
                this.selectionIsOpened = !this.selectionIsOpened;
            }
        },
        mounted() {
            this.addAutoCloseSelection();
        },
        unmounted() {
            this.removeAutoCloseSelection();
        }
    }
</script>